const mutations = {
  login (state, payload) {
    state.login = payload.login
    state.refreshToken = payload.refreshToken
    state.token = payload.token
  },
  authData (state) {
    if (state.login) {
      return
    }

    if (localStorage.getItem('token') || localStorage.getItem('login')) {
      state.refreshToken = localStorage.getItem('refreshToken') || ''
      state.token = localStorage.getItem('token') || ''
      state.login = !!localStorage.getItem('login')
    }
  }
}

export default mutations
